export default "__VITE_ASSET__00ccdb71__"